// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    myGss: This.GoalSetting.ForList[];
    teamGss: This.GoalSetting.ForList[];
    timelineChart: Sys.Types.ChartConfiguration;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingHome',
    templateUrl: './GoalSettingHome.html',
    styleUrls: ['./GoalSettingHome.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingHome extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingHome';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_35 = (screen: Properties) => ['column_34', 'column_29', 'column_28', 'column_27', 'column_60'];
    $validators: Record<number, ValidationRules> = {

    };
    var_myGss = proxySignal<This.GoalSetting.ForList[]>(undefined as any);
    var_teamGss = proxySignal<This.GoalSetting.ForList[]>(undefined as any);
    var_timelineChart = proxySignal<Sys.Types.ChartConfiguration>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get myGss() { return component.var_myGss() },
                set myGss(value: This.GoalSetting.ForList[]) { component.var_myGss.set(value) },
                get teamGss() { return component.var_teamGss() },
                set teamGss(value: This.GoalSetting.ForList[]) { component.var_teamGss.set(value) },
                get timelineChart() { return component.var_timelineChart() },
                set timelineChart(value: Sys.Types.ChartConfiguration) { component.var_timelineChart.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.myGss = (undefined)
            if (!isVariablesInitialized) this.screen.teamGss = (undefined)
            if (!isVariablesInitialized) this.screen.timelineChart = (undefined)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

        this.router.events.pipe(
            filter(e => e instanceof NavigationSkipped),
            takeUntilDestroyed(),
        ).subscribe(() => {
            this.action_onNavigationSkipped(null)
        })

    }

    _DataTableBlock_collectionCodeSignal_35(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.teamGss)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_35($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({})
    }

    _DataTableColumnBlock_cellText_34($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: This.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.cycle.getDateRange())
    }

    _DataTableColumnBlock_cellText_28($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: This.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.status.label)
    }

    _DataTableColumnBlock_cellText_60($scope: any): any {
        let { app, screen, $pathSegments, $disabled, gs, gsIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, gs: This.GoalSetting.ForList, gsIndex: number } = $scope ?? {}

        return (gs.nextActionDeadlineStr)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            const openCyclesPromise = This.Db.loadByCondition(This.GoalSettingCycle, {
                where: { status$id: This.GoalSettingCycleStatus.Open.id }
            })
            await this.action_reloadGoalSettings()

            const openCycles = await openCyclesPromise
            screen.timelineChart = {} as any




            // Charts

            interface ChevronStep {
                name: string;
                endDate: Date;
                /**
                 * Required on the first step of a chevron. On later steps, omitting it
                 * chains this step's start to the previous step's endDate.
                 */
                startDate?: Date;
                /** Overrides the chevron's color for this step only. */
                color?: string;
                /** true (default) = angled point at the end of this step. false = flat vertical line. */
                openEnded?: boolean;
                openStarted?: boolean;
            }

            interface Chevron {
                steps: ChevronStep[];
                /** Default color for every step in this chevron, unless a step overrides it. */
                color?: string;
                /** Optional row label, defaults to "Row N". */
                label?: string;
                milestones?: { name: string; date: Date }[];
            }

            // Teach Chart.js's TypeScript types about the new 'chevron' chart type.
            // Without this, `type: 'chevron'` and the ChevronController options
            // won't type-check. It behaves like 'bar' for data/options shape.


            const DEFAULT_COLORS = ['#4C6EF5', '#12B886', '#F59F00', '#E64980', '#7048E8', '#15AABF'];

            function fmt(date) {
                return date instanceof Date
                    ? date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
                    : date;
            }

            // Defensive coercion: Chart.js needs real Date objects (or ISO strings via
            // its date adapter) to place things correctly on a time scale. A stray
            // null/undefined/malformed value silently collapses to the Unix epoch
            // (Jan 1 1970) instead of failing loudly, so we coerce and warn here.
            function toValidDate(value: Date, context: string): Date {
                const d = value instanceof Date ? value : new Date(value);
                if (isNaN(d.getTime())) {
                    console.warn(
                        `[buildChevronChartConfig] Invalid date for ${context}:`,
                        value,
                        '- this will render at the Unix epoch (1970) until fixed.'
                    );
                }
                return d;
            }

            // ---------------------------------------------------------------------
            // 3b. Plugin: draws each milestone's name centered under its diamond,
            //     always-on (no hover needed). Scoped to this chart via the
            //     returned config's `plugins` array, not globally registered.
            // ---------------------------------------------------------------------
            function createMilestoneLabelPlugin(options: { fontColor: string; font: string; offset: number }) {
                return {
                    id: 'milestoneLabels',
                    afterDatasetsDraw(chart: any) {
                        const { ctx } = chart;
                        chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
                            if (dataset.type !== 'scatter') return;
                            const meta = chart.getDatasetMeta(datasetIndex);
                            if (!meta.visible) return;

                            ctx.save();
                            ctx.font = options.font;
                            ctx.fillStyle = options.fontColor;
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'top';

                            meta.data.forEach((point: any, i: number) => {
                                const raw = dataset.data[i];
                                const name = raw?.name;
                                if (!name) return;
                                const radius = point.options?.radius ?? dataset.pointRadius ?? 8;
                                ctx.fillText(name, point.x, point.y + radius + options.offset);
                            });

                            ctx.restore();
                        });
                    },
                };
            }

            function createTodayLinePlugin(options: { color: string; label: string; font: string }) {
                return {
                    id: 'todayLine',
                    afterDatasetsDraw(chart: any) {
                        const xScale = chart.scales['x'];
                        const { ctx, chartArea } = chart;
                        if (!xScale || !chartArea) return;

                        const x = xScale.getPixelForValue(Date.now());
                        if (x < chartArea.left || x > chartArea.right) return; // today is outside the visible range

                        ctx.save();
                        ctx.strokeStyle = options.color;
                        ctx.lineWidth = 1.5;
                        ctx.setLineDash([4, 4]);
                        ctx.beginPath();
                        ctx.moveTo(x, chartArea.top);
                        ctx.lineTo(x, chartArea.bottom);
                        ctx.stroke();

                        ctx.setLineDash([]);
                        ctx.font = options.font;
                        ctx.fillStyle = options.color;
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        ctx.fillText(options.label, x, chartArea.top - 2);
                        ctx.restore();
                    },
                };
            }

            // ---------------------------------------------------------------------
            // 4. Build the Chart.js config from a list of chevrons
            // ---------------------------------------------------------------------
            function buildChevronChartConfig(
                chevrons: Chevron[],
                options: {
                    colors?: string[];
                    barThickness?: number;
                    stepBorderColor?: string;
                    stepBorderWidth?: number;
                    milestoneColor?: string;
                    milestoneBorderColor?: string;
                    timeUnit?: 'day' | 'week' | 'month' | 'quarter';
                    xMin?: Date | string | number;
                    xMax?: Date | string | number;
                    showMilestoneLabels?: boolean;
                    milestoneLabelColor?: string;
                    milestoneLabelFont?: string;
                    pointDepth?: number;    // px; default barThickness / 2
                    overhangRatio?: number; // default 1/3, only affects open edges
                    showTodayLine?: boolean
                    todayLineColor?: string
                    todayLabel?: string
                    todayLabelFont?: string
                } = {} as any
            ) {
                const {
                    colors = DEFAULT_COLORS,
                    barThickness = 36,
                    // A thin border helps visually separate same-colored adjacent steps
                    // within one chevron, since they now sit flush against each other.
                    stepBorderColor = 'rgba(255, 255, 255, 0.6)',
                    stepBorderWidth = 1,
                    milestoneColor = '#ffffff',
                    milestoneBorderColor = '#212529',
                    timeUnit = 'month',
                    xMin,
                    xMax,
                    showMilestoneLabels = true,
                    milestoneLabelColor = '#495057',
                    milestoneLabelFont = '11px sans-serif',
                    pointDepth = barThickness / 2,
                    overhangRatio = 1 / 3,
                    showTodayLine = true,
                    todayLineColor = '#e03131',
                    todayLabel = 'Today',
                    todayLabelFont = '11px sans-serif',
                } = options;

                const labels = chevrons.map((c, i) => c.label ?? `Row ${i + 1}`);
                const chevronColors = chevrons.map((c, i) => c.color ?? colors[i % colors.length]);

                // Flatten every chevron's steps into one dataset. Each entry keeps its
                // own row (y) and resolved color, so multiple steps can chain together
                // end-to-end on the same line. Using the object form {x: [start, end], y}
                // — rather than a positional [start, end] array — is what lets several
                // entries share the same category (row): Chart.js's documented floating
                // bar format supports either, but only the object form allows more than
                // one bar per category.
                const stepEntries = chevrons.flatMap((chevron, ci) => {
                    const rowLabel = labels[ci];
                    const rowColor = chevronColors[ci];
                    let previousEnd: Date | undefined;

                    let previousOpenEnded = true; // unused for si===0, reset per chevron

                    return chevron.steps.map((step, si) => {
                        let rawStart = step.startDate;
                        if (!rawStart) {
                            if (si === 0) {
                                console.warn(
                                    `[buildChevronChartConfig] chevrons[${ci}].steps[0] is missing startDate ` +
                                    `(required on the first step). Falling back to its endDate, which will ` +
                                    `render as a zero-width step.`
                                );
                                rawStart = step.endDate;
                            } else {
                                rawStart = previousEnd;
                            }
                        }
                        previousEnd = step.endDate;
                        const endOpen = step.openEnded ?? true;
                        const startOpen = step.openStarted ?? (si === 0 ? false : previousOpenEnded);
                        previousOpenEnded = endOpen;

                        return {
                            x: [
                                toValidDate(rawStart as Date, `chevrons[${ci}].steps[${si}].startDate`),
                                toValidDate(step.endDate, `chevrons[${ci}].steps[${si}].endDate`),
                            ],
                            y: rowLabel,
                            name: step.name,
                            color: step.color ?? rowColor,
                            startOpen,
                            endOpen,
                        };
                    });
                });

                // One flat list of milestone points; each carries its own row (y = label)
                // and the milestone name for tooltips/labels.
                const milestonePoints = chevrons.flatMap((chevron, ci) => {
                    const rowLabel = labels[ci];
                    return (chevron.milestones ?? []).map((m, mi) => ({
                        x: toValidDate(m.date, `chevrons[${ci}].milestones[${mi}].date`),
                        y: rowLabel,
                        name: m.name,
                    }));
                });

                // Cast at the boundary: this is a mixed chart (chevron + scatter
                // datasets), and Chart.js's generic ChartConfiguration<T> isn't set up
                // to express "one dataset type per entry" cleanly. The runtime shape
                // is exactly what Chart.js expects for a mixed chart.
                return {
                    data: {
                        labels,
                        datasets: [
                            {
                                type: 'chevron',
                                label: 'Steps',
                                data: stepEntries,
                                clip: false,
                                backgroundColor: (ctx: any) => ctx.raw?.color ?? DEFAULT_COLORS[0],
                                borderColor: stepBorderColor,
                                borderWidth: stepBorderWidth,
                                barThickness,
                                categoryPercentage: 0.7,
                                barPercentage: 0.9,
                                pointDepth,
                                overhangRatio,
                                startOpen: (ctx: any) => ctx.raw?.startOpen,
                                endOpen: (ctx: any) => ctx.raw?.endOpen,
                            },
                            {
                                type: 'scatter',
                                label: 'Milestones',
                                data: milestonePoints,
                                showLine: false,
                                pointStyle: 'rectRot', // diamond
                                pointRadius: 8,
                                pointHoverRadius: 10,
                                backgroundColor: milestoneColor,
                                borderColor: milestoneBorderColor,
                                borderWidth: 2,
                                order: -1, // draw on top of the chevron steps
                            },
                        ],
                    },
                    options: {
                        indexAxis: 'y',
                        responsive: true,
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                top: showTodayLine ? 24 : 10,
                                right: 30,
                                bottom: showMilestoneLabels ? 26 : 10,
                                left: 10,
                            }
                        },
                        scales: {
                            x: {
                                type: 'time',
                                position: 'top',
                                time: { unit: timeUnit, tooltipFormat: 'PP' },
                                grid: { color: 'rgba(0,0,0,0.06)' },
                                ...(xMin !== undefined ? { min: xMin } : {}),
                                ...(xMax !== undefined ? { max: xMax } : {}),
                            },
                            y: {
                                type: 'category',
                                labels,
                                // First chevron at the top, subsequent ones stacked below it.
                                reverse: true,
                                offset: true,
                                grid: { display: false },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    // Only show the "Milestones" legend entry; step colors vary
                                    // per-chevron/step so a single swatch would be misleading.
                                    // filter: (item) => item.text === 'Milestones',
                                    filter: () => false,
                                },
                            },
                            tooltip: {
                                callbacks: {
                                    title: (items) => {
                                        const item = items[0];
                                        return item.raw.name ?? item.label;
                                    },
                                    label: (item) => {
                                        if (item.dataset.type === 'chevron') {
                                            const [start, end] = item.raw.x;
                                            return `${fmt(start)} → ${fmt(end)}`;
                                        }
                                        return fmt(item.raw.x);
                                    },
                                },
                            },
                        },
                    },
                    plugins: [
                        ...(showMilestoneLabels
                            ? [createMilestoneLabelPlugin({ fontColor: milestoneLabelColor, font: milestoneLabelFont, offset: 12 })]
                            : []),
                        ...(showTodayLine
                            ? [createTodayLinePlugin({ color: todayLineColor, label: todayLabel, font: todayLabelFont })]
                            : []),
                    ],
                } as any;
            }

            const cycles = openCycles.toReversed().map((cycle, cycleIdx) => {
                const start = cycle.startDate
                const selfReviewStart = Sys.Date.fns.addDays(cycle.selfReviewDeadline, -14)
                // const end = Sys.Date.fns.add(start, { years: 1, days: -1 })

                return {
                    label: `Development cycle ${cycle.getDateRange()}`, steps: [
                        { startDate: start, endDate: cycle.goalsDeadline, name: 'Goal setting', openStarted: cycleIdx == 0 },
                        { endDate: selfReviewStart, name: '', color: '#eeeeee' },
                        { endDate: cycle.selfReviewDeadline, name: 'Self-review' },
                        { endDate: cycle.managerReviewDeadline, name: 'Manager assessment' },
                    ] as ChevronStep[], milestones: [
                        // { name: 'Goals agreed', date: cycle.goalsDeadline },
                        // { name: 'Self-review done', date: cycle.selfReviewDeadline },
                        ...(cycleIdx < openCycles.length - 1 ? [{ name: 'Year-end discussion', date: cycle.startDate }] : []),
                        ...(cycleIdx ? [{ name: 'Year-end discussion', date: cycle.managerReviewDeadline }] : []),
                    ]
                }
            })
            screen.timelineChart = buildChevronChartConfig(cycles, {
                xMin: new Date(Math.min(...cycles.map(c => c.steps[0]?.startDate.getTime()))),
            })
            //   new Date(Math.min(...cycles.map(c => c.startDate))),
        }
    }

    async action_reloadGoalSettings($event?: any) {
        const { app, screen, output } = this
        {
            const result = await This.GoalSettingUtil.getMyAndTeamsOpenGoalSettings()
            screen.myGss = result.mine
            screen.teamGss = result.team
        }
    }

    async action_onNavigationSkipped($event?: any) {
        const { app, screen, output } = this
        {
            await this.action_reloadGoalSettings()
            Sys.App.showNotification('success', 'Personal developments re-loaded')
        }
    }
}
